module.exports = __webpack_public_path__ + "img/71d08c65-8aa6-4396-9e1e-3c0c8b88f97e.fe4f321.png";